import { getContratoEdicaoId } from './escalaContratos';

// Compare com o formulário inicialmente exibido, pois os controles históricos
// mostram horas inteiras e não representam todos os minutos persistidos.
export const construirPatchItemAlterado = (atual = {}, inicial = {}) => {
	const patch = {};
	Object.entries(atual).forEach(([campo, valor]) => {
		if (valor === undefined) return;
		if (campo === 'horario') {
			const horario = Object.fromEntries(
				Object.entries(valor || {}).filter(
					([chave, dado]) => dado !== undefined && dado !== inicial.horario?.[chave],
				),
			);
			if (Object.keys(horario).length) patch.horario = horario;
		} else if (JSON.stringify(valor) !== JSON.stringify(inicial[campo])) {
			patch[campo] = valor;
		}
	});
	return patch;
};

export const construirPatchLoteSemHorario = (payload = {}, itemIds = []) => {
	const { horario, recorrencia, periodo, item_referencia_id, ...campos } = payload;
	return { ...campos, item_ids: itemIds };
};

export const criarControleTrocaEscala = () => {
	let decisao = null;
	let emAndamento = false;
	return {
		iniciar(assinatura) {
			if (emAndamento) return null;
			if (decisao?.assinatura !== assinatura) {
				decisao = {
					assinatura,
					chave: (typeof window !== 'undefined' && window.crypto?.randomUUID?.()) || `escala-troca-${Date.now()}-${Math.random().toString(36).slice(2)}`,
				};
			}
			emAndamento = true;
			return {
				idempotencyKey: decisao.chave,
				finalizar(sucesso = false) {
					emAndamento = false;
					if (sucesso) decisao = null;
				},
			};
		},
	};
};

// Uma resposta perdida de POST só pode ser reconciliada por identidade
// contratual e horário. Cadastro inline sem IDs não permite essa conclusão.
export const reconciliarCriacaoIncerta = (grade = {}, body = {}) => {
	const profissionalId = Number(body.profissional?.id || 0);
	const contratoId = Number(body.profissional?.vinculo_id || 0);
	if (!profissionalId || !contratoId) return 'indeterminada';
	const visualizacao = grade.visualizacao || grade.grade;
	if (!Array.isArray(visualizacao?.setores)) return 'indeterminada';
	const estabelecimento = grade.contexto?.estabelecimento;
	const estabelecimentoId = String(estabelecimento?.cnes || estabelecimento?.id || (typeof estabelecimento !== 'object' ? estabelecimento : '') || '');
	if (body.estabelecimento && estabelecimentoId && estabelecimentoId !== String(body.estabelecimento)) return 'indeterminada';
	const setorId = String(body.contexto_competencia?.setor_id || '');
	if (String(grade.contexto?.setor?.id || '') !== setorId &&
		!visualizacao.setores.some((setor) => String(setor.id) === setorId)) return 'indeterminada';
	const itens = [
		...(Array.isArray(grade.itens) ? grade.itens.map((item) => ({ item, setorContexto: grade.contexto?.setor?.id })) : []),
		...visualizacao.setores.flatMap((setor) => (setor.linhas || []).flatMap((linha) => (linha.celulas || []).flatMap((celula) => (celula.cards || []).map((item) => ({ item, setorContexto: setor.id }))))),
	];
	const normalizarHora = (valor) => String(valor || '').slice(0, 8).padEnd(8, ':00');
	const encontrados = new Set();
	let possuiEquivalenteSemSetor = false;
	itens.forEach(({ item, setorContexto }) => {
		const horario = item.edicao?.horario || item.dados_edicao?.horario || item.horario || item.dados_edicao || item;
		const pessoaId = Number(item.edicao?.profissional?.id || item.profissional?.id || item.profissional_id || 0);
		if (pessoaId === profissionalId && getContratoEdicaoId(item) === contratoId &&
			String(item.tipo_item || item.edicao?.tipo_item || '').toUpperCase() === body.tipo_item &&
			String(horario.data || '') === String(body.horario?.data || '') &&
			normalizarHora(horario.hora_inicio) === normalizarHora(body.horario?.hora_inicio) &&
			normalizarHora(horario.hora_fim) === normalizarHora(body.horario?.hora_fim)) {
			const setorDoItem = String(item.edicao?.contexto_competencia?.setor_id || item.contexto_competencia?.setor_id || item.setor?.id || item.setor_id || (typeof item.setor !== 'object' ? item.setor : '') || setorContexto || '');
			if (!/^\d+$/.test(setorDoItem)) {
				possuiEquivalenteSemSetor = true;
				return;
			}
			if (setorDoItem !== setorId) return;
			const id = item.id || item.edicao?.id || item.dados_edicao?.id;
			if (id) encontrados.add(String(id));
		}
	});
	return encontrados.size === 1 ? 'confirmada' : encontrados.size || possuiEquivalenteSemSetor ? 'indeterminada' : 'ausente';
};
